import { DataTable } from '@frontend/app/refresh-components';
import { SortingState } from '@tanstack/react-table';
import React from 'react';
import { PostTypeInsights } from '@frontend/gql/social/graphql';
import { NetworksTableColumn } from './config/defaultNetworksTableColumns';

type NetworksTableRow = Omit<PostTypeInsights, 'memberId' | 'accountEntityId'>;

interface NetworksTableProps {
  data: NetworksTableRow[];
  selectedColumns: NetworksTableColumn<NetworksTableRow>[];
  currentPage: number;
  pageSize: number;
  globalFilter: string;
  handleSortingChange: (sorting: SortingState) => void;
  sorting: SortingState;
}

export const NetworksTable = ({
  data,
  selectedColumns,
  currentPage,
  pageSize,
  globalFilter,
  handleSortingChange,
  sorting,
}: NetworksTableProps) => {
  const columnsToShow = selectedColumns.filter((col) => !col.hidden);
  return (
    <DataTable
      bordered
      paginated
      sortable
      filterable
      disableVirtualization
      columns={columnsToShow}
      data={data}
      globalFilter={globalFilter}
      paginationState={{ pageIndex: currentPage, pageSize }}
      onSortingChange={handleSortingChange}
      sorting={sorting}
    />
  );
};

export default NetworksTable;
